import React, { Fragment} from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';

import AboutUs from './About';
import Download from './download';
import Product from './Product';
import Solution from './Solution';
import Bottom from './components/bottom';
import Header from './components/header';
import Trial from './Trial';
import Question from './Question';
import Tutorial from './Tutorial'
import Technology from './Technology';
import Cooperation from './Cooperation';

export default () => (
  
  <Fragment>
    <Header />
      <Switch>
      <Route path="/about" component={AboutUs} />
        <Route path="/download" component={Download} />
        <Route path="/product" component={Product} />
        <Route path="/solution" component={Solution} />
        <Route path="/trial" component={Trial} />
        <Route path="/question" component={Question}/>
        <Route path="/tutorial" component={Tutorial}/>
        <Route path="/technology" component={Technology}/>  
        <Route path="/cooperation" component={Cooperation}/>
      </Switch>
    <Bottom />
  </Fragment>
)

// 技术介绍 、 合作案例


// WEBPACK FOOTER //
// ./src/Framework.js